"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withMobileDialog.default;
  }
});

var _withMobileDialog = _interopRequireDefault(require("./withMobileDialog"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/withMobileDialog/index.js
// module id = 1097
// module chunks = 0